import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { InformationDialogData } from './information-dialog.interface';

@Component({
    selector: 'app-information-dialog',
    templateUrl: './information-dialog.component.html',
    styleUrls: ['./information-dialog.component.scss'],
    standalone: false
})
export class InformationDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<InformationDialogComponent>,
    private translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: InformationDialogData,
  ) {
    if (this.data) {
      if (!this.data.title) {
        this.data.title = this.translate.instant('INFORMATION_DIALOG.INFORMATION');
      }
    }
  }

  public close(): void {
    this.dialogRef.close();
  }
}
